import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function EventCollectionIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22.13 8.63V6.635c0-1.973 0-2.959-.384-3.712a3.522 3.522 0 0 0-1.539-1.54C19.454 1 18.467 1 16.495 1h-9.86c-1.973 0-2.959 0-3.712.384a3.522 3.522 0 0 0-1.54 1.539C1 3.676 1 4.663 1 6.635v9.86c0 1.973 0 2.959.384 3.712a3.522 3.522 0 0 0 1.539 1.54c.753.383 1.74.383 3.712.383H8.63"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.392 6.37V5M7.795 7.795l-.969-.969m.969 8.22-.969.968m8.22-8.219.968-.969M6.37 11.392H5m12.66 6.566-2.274 4.226c-.26.482-.39.724-.547.785a.456.456 0 0 1-.411-.04c-.142-.09-.223-.353-.384-.877L10.886 11.8c-.132-.428-.198-.642-.145-.787a.456.456 0 0 1 .271-.271c.145-.053.359.013.787.145l10.253 3.158c.524.162.786.242.877.384a.456.456 0 0 1 .04.411c-.061.157-.303.287-.786.546l-4.225 2.276a.96.96 0 0 0-.14.083.452.452 0 0 0-.074.075c-.025.031-.044.067-.083.139Z"
      />
    </Icon>
  );
}
